<header class="site-header" [class.dark-theam]="isDarkHeader" [class.arebic-content]="textDirection == 'rtl'">
    <div class="container">
        <nav>
            <div class="brand-logo cursor">
                <img routerLink="/"
                    [src]="isDarkHeader ? 'assets/images/dark-logo-icon.svg' :'assets/images/taly-dark-icon.svg'"
                    alt="Brand-logo">
            </div>
            <ul class="menu-list">
                <ng-container *ngFor="let menu of heaerItems;let i =index">
                    <li *ngIf="!menu?.children ; else dropdown" (click)="navRedirection(menu,i)"
                        [class.download]="menu?.type == 'download'" [class.active]="i === isActive " translate>
                        {{menu.label}}
                    </li>
                    <ng-template #dropdown>
                        <li translate class="main-menu">
                            <p-dropdown [formControl]="menuCtrl" [options]="menu?.children" [optionLabel]="'link'"
                                [optionValue]="'link'" (onShow)="dropdownOpen = true" (onHide)="dropdownOpen = false"
                                (onBlur)="dropdownOpen=false">

                                <ng-template pTemplate="selectedItem">
                                    <div class="flex align-items-center gap-2 sub-menu">
                                        <div translate>SITE_HEADER.FOR_PARTNER</div>
                                        <i class="pi"
                                            [ngClass]="{'pi-angle-down': !dropdownOpen, 'pi-angle-up': dropdownOpen}">
                                        </i>
                                    </div>
                                </ng-template>

                                <ng-template let-item pTemplate="item">
                                    <div class="item-list" [class.active]="menuCtrl?.value == item.link"
                                        (click)="navRedirection(item, i)">
                                        <div translate>{{ item.label }}</div>
                                        <img src="assets/images/link-arrow.svg">
                                    </div>
                                </ng-template>
                            </p-dropdown>

                        </li>
                    </ng-template>
                </ng-container>


                <li *ngIf="heaerItems.length > 0" class="is-grey" [ngClass]="{ 'hovered': isHovered }"
                    (mouseenter)="isHovered = true" (mouseleave)="isHovered = false" (click)="toggleText()">
                    <div class="language">
                        <img [src]="isGreyHeader || isHovered ? getgreySrc(): getDarkSrc()" alt="lang-logo">
                        <label for="lang" class="language-name" translate>LANGUAGE</label>
                    </div>
                </li>




                <li *ngIf="heaerItems.length > 0" class="is-blue" [ngClass]="{ 'hovered': isHovered }"
                    (mouseenter)="isHovered = true" (mouseleave)="isHovered = false" (click)="toggleText()">
                    <div class="language">
                        <img [src]="isHovered ? 'assets/images/hover-lang-logo.svg' : (isDarkHeader ? 'assets/images/blue-lang.svg' : 'assets/images/lang-blue-light.svg')"
                            alt="lang-logo">
                        <label for="lang" class="language-name" translate>LANGUAGE</label>
                    </div>
                </li>
            </ul>
            <ul class="menu-list-responsive" *ngIf="isMenuOpen">
                <div class="cros-icon">
                    <img class="close-icon" src="assets/images/menu-close-icon.svg" (click)="isMenuOpen = false"
                        alt="menu-icon">
                </div>
                <ng-container *ngFor="let menu of heaerItems;let i = index">


                    <li *ngIf="!menu?.children ; else dropdown" (click)="navRedirection(menu,i)" translate
                        [class.active]="i == isActive">
                        {{menu.label}}
                        <i *ngIf="!menu?.children" class="pi pi-angle-right"></i>
                    </li>
                    <ng-template #dropdown>
                        <li translate="" [class.active]="i == isActive" class="last-child">

                            <p-dropdown [options]="menu?.children">
                                <ng-template pTemplate="selectedItem">

                                    <div class="dropdown-list">
                                        <div translate>SITE_HEADER.FOR_PARTNER </div>
                                        <i class="pi pi-angle-down"></i>
                                    </div>
                                </ng-template>
                                <ng-template let-item pTemplate="item">
                                    <div class="flex align-items-center gap-2 item-list"
                                        (click)="navRedirection(item,i)">
                                        <div translate>{{item.label}} </div>
                                        <i class="pi pi-angle-right"></i>


                                    </div>
                                </ng-template>
                            </p-dropdown>
                        </li>
                    </ng-template>
                </ng-container>

            </ul>




            <div class="language icon is-grey-mob " (click)="toggleText()">
                <img [src]="isGreyHeader || isHovered ? getgreySrc(): getDarkSrc()" alt="lang-logo">
                <label for="lang" translate>LANGUAGE</label>
            </div>
            <div class="language icon is-blue-mob " (click)="toggleText()">
                <img [src]="isHovered ? 'assets/images/hover-lang-logo.svg' : (isDarkHeader ? 'assets/images/blue-lang.svg' : 'assets/images/lang-blue-light.svg')"
                    alt="lang-logo">
                <label for="lang" translate>LANGUAGE</label>
            </div>
            <img class="menu-bar" (click)="isMenuOpen = true"
                [src]="isDarkHeader ?  'assets/images/dark-menu-bar.svg' :'assets/images/menu-icon.svg'">

        </nav>
    </div>
</header>

<p-confirmDialog #cd>
    <ng-template pTemplate="header">
        <div>
            <h3 class="title" [innerHTML]="'APP.TITLE' | translate"></h3>
            <p class="desc" translate> APP.DESC </p>
        </div>
        <div class="qr-code-container">
            <img class="qr-code" src="assets/images/taly-qr-code.svg" alt="QR Code">
        </div>
    </ng-template>
    <ng-template pTemplate="icon">
    </ng-template>
    <ng-template pTemplate="message">
    </ng-template>
    <ng-template pTemplate="footer">
        <button class="btn btn-sky-blue w-100" translate (click)="cd.reject()">
            BUTTON.CLOSE
        </button>
    </ng-template>
</p-confirmDialog>